export default __webpack_public_path__ + "static/media/starting_line.fc0257fc.jpg";